const romanianMessages = {
  ra: {
    action: {
      add_filter: 'Adaugă filtru',
      add: 'Adaugă',
      back: 'Înapoi',
      bulk_actions: '%{smart_count} selectate',
      cancel: 'Anulează',
      clear_array_input: 'Golește lista',
      clear_input_value: 'Golește valoarea',
      clone: 'Clonează',
      confirm: 'Confirmă',
      create: 'Creează',
      create_item: 'Creează %{item}',
      delete: 'Șterge',
      edit: 'Editează',
      export: 'Exportă',
      list: 'Listă',
      refresh: 'Actualizează',
      remove_filter: 'Elimină filtrul',
      remove_all_filters: 'Elimină toate filtrele',
      remove: 'Elimină',
      save: 'Salvează',
      search: 'Caută',
      select_all: 'Selectează tot',
      select_row: 'Selectează rândul',
      show: 'Vizualizează',
      sort: 'Sortează',
      undo: 'Anulează',
      unselect: 'Deselectează',
      expand: 'Extinde',
      close: 'Închide',
      open_menu: 'Deschide meniu',
      close_menu: 'Închide meniu',
      update: 'Actualizează',
      move_up: 'Mută sus',
      move_down: 'Mută jos',
      open: 'Deschide',
      toggle_theme: 'Schimbă tema',
      select_columns: 'Coloane',
    },
    boolean: {
      true: 'Da',
      false: 'Nu',
      null: ' ',
    },
    page: {
      create: 'Creează %{name}',
      dashboard: 'Panou principal',
      edit: '%{name} %{recordRepresentation}',
      error: 'Ceva nu a funcționat',
      list: '%{name}',
      loading: 'Se încarcă',
      not_found: 'Pagina nu a fost găsită',
      show: '%{name} %{recordRepresentation}',
      empty: 'Nu există %{name} încă.',
      invite: 'Doriți să adăugați unul?',
    },
    input: {
      file: {
        upload_several: 'Trageți fișierele aici sau apăsați pentru a selecta.',
        upload_single: 'Trageți un fișier aici sau apăsați pentru a selecta.',
      },
      image: {
        upload_several: 'Trageți imaginile aici sau apăsați pentru a selecta.',
        upload_single: 'Trageți o imagine aici sau apăsați pentru a selecta.',
      },
      references: {
        all_missing: 'Nu se pot găsi datele referențiate.',
        many_missing: 'Cel puțin o referință nu pare a fi disponibilă.',
        single_missing: 'Referința asociată nu pare a fi disponibilă.',
      },
      password: {
        toggle_visible: 'Ascunde parola',
        toggle_hidden: 'Afișează parola',
      },
    },
    message: {
      about: 'Despre',
      are_you_sure: 'Sunteți sigur?',
      auth_error: 'A apărut o eroare la validarea tokenului de autentificare.',
      bulk_delete_content: 'Sunteți sigur că doriți să ștergeți %{name}? |||| Sunteți sigur că doriți să ștergeți aceste %{smart_count} elemente?',
      bulk_delete_title: 'Șterge %{name} |||| Șterge %{smart_count} %{name}',
      bulk_update_content: 'Sunteți sigur că doriți să actualizați %{name}? |||| Sunteți sigur că doriți să actualizați aceste %{smart_count} elemente?',
      bulk_update_title: 'Actualizează %{name} |||| Actualizează %{smart_count} %{name}',
      clear_array_input: 'Sunteți sigur că doriți să goliți întreaga listă?',
      delete_content: 'Sunteți sigur că doriți să ștergeți acest element?',
      delete_title: 'Șterge %{name} #%{id}',
      details: 'Detalii',
      error: 'A apărut o eroare și cererea nu a putut fi procesată.',
      invalid_form: 'Formularul nu este valid. Verificați erorile.',
      loading: 'Pagina se încarcă, vă rugăm așteptați.',
      no: 'Nu',
      not_found: 'Ați introdus un URL greșit sau ați urmat un link incorect.',
      yes: 'Da',
      unsaved_changes: 'Unele modificări nu au fost salvate. Sunteți sigur că doriți să le ignorați?',
    },
    navigation: {
      no_results: 'Nu au fost găsite rezultate',
      no_more_results: 'Pagina %{page} depășește limitele. Încercați pagina anterioară.',
      page_out_of_boundaries: 'Pagina %{page} depășește limitele',
      page_out_from_end: 'Nu se poate naviga după ultima pagină',
      page_out_from_begin: 'Nu se poate naviga înainte de pagina 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} din %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} din mai mult de %{offsetEnd}',
      current_page: 'Pagina %{page}',
      page: 'Mergi la pagina %{page}',
      first: 'Prima pagină',
      last: 'Ultima pagină',
      next: 'Pagina următoare',
      previous: 'Pagina anterioară',
      page_rows_per_page: 'Rânduri pe pagină:',
      skip_nav: 'Mergi la conținut',
    },
    sort: {
      sort_by: 'Sortează după %{field} %{order}',
      ASC: 'crescător',
      DESC: 'descrescător',
    },
    auth: {
      auth_check_error: 'Vă rugăm să vă autentificați pentru a continua',
      user_menu: 'Profil',
      username: 'Utilizator',
      password: 'Parolă',
      sign_in: 'Autentificare',
      sign_in_error: 'Autentificarea a eșuat, încercați din nou',
      logout: 'Deconectare',
    },
    notification: {
      updated: 'Element actualizat |||| %{smart_count} elemente actualizate',
      created: 'Element creat',
      deleted: 'Element șters |||| %{smart_count} elemente șterse',
      bad_item: 'Element incorect',
      item_doesnt_exist: 'Elementul nu există',
      http_error: 'Eroare de comunicare cu serverul',
      data_provider_error: 'Eroare dataProvider. Verificați consola.',
      i18n_error: 'Nu se pot încărca traducerile pentru limba specificată',
      canceled: 'Acțiune anulată',
      logged_out: 'Sesiunea a expirat, vă rugăm reconectați-vă.',
      not_authorized: 'Nu sunteți autorizat să accesați această resursă.',
    },
    validation: {
      required: 'Câmp obligatoriu',
      minLength: 'Minim %{min} caractere',
      maxLength: 'Maxim %{max} caractere',
      minValue: 'Valoarea minimă este %{min}',
      maxValue: 'Valoarea maximă este %{max}',
      number: 'Trebuie să fie un număr',
      email: 'Trebuie să fie un email valid',
      oneOf: 'Trebuie să fie una din: %{options}',
      regex: 'Trebuie să respecte formatul specificat (regexp): %{pattern}',
    },
    saved_queries: {
      label: 'Căutări salvate',
      query_name: 'Nume căutare',
      new_label: 'Salvează căutarea curentă...',
      new_dialog_title: 'Salvează căutarea curentă ca',
      remove_label: 'Elimină căutarea salvată',
      remove_label_with_name: 'Elimină căutarea "%{name}"',
      remove_dialog_title: 'Elimină căutarea salvată?',
      remove_message: 'Sunteți sigur că doriți să eliminați acest element din lista de căutări salvate?',
      help: 'Filtrați lista și salvați această căutare pentru mai târziu',
    },
  },
  resources: {
    products: {
      name: 'Produs |||| Produse',
      fields: {
        name: 'Nume produs',
        category: 'Categorie',
        brand: 'Brand',
        price: 'Preț',
        stock: 'Stoc',
        status: 'Status',
        createdAt: 'Data creării',
        featured: 'Recomandat',
        onSale: 'La reducere',
        sku: 'SKU',
      },
    },
    preturi: {
      name: 'Preț |||| Prețuri',
    },
    orders: {
      name: 'Comandă |||| Comenzi',
      fields: {
        orderNumber: 'Nr. comandă',
        status: 'Status',
        grandTotal: 'Total',
        createdAt: 'Data comenzii',
        paymentMethod: 'Metodă plată',
        paymentStatus: 'Status plată',
      },
    },
    users: {
      name: 'Utilizator |||| Utilizatori',
      fields: {
        name: 'Nume',
        email: 'Email',
        role: 'Rol',
        createdAt: 'Data înregistrării',
      },
    },
    reviews: {
      name: 'Recenzie |||| Recenzii',
      fields: {
        userName: 'Client',
        rating: 'Evaluare',
        status: 'Status',
        createdAt: 'Data',
        comment: 'Comentariu',
        title: 'Titlu',
      },
    },
    'contact-messages': {
      name: 'Mesaj contact |||| Mesaje contact',
      fields: {
        name: 'Nume',
        email: 'Email',
        phone: 'Telefon',
        subject: 'Subiect',
        message: 'Mesaj',
        status: 'Status',
        createdAt: 'Data',
      },
    },
  },
};

export default romanianMessages;
